import * as t from 'io-ts';

/**
 * A product to be used in a Layout document
 */
export const LayoutProduct = t.type({ productId: t.string });

export type LayoutProduct = t.TypeOf<typeof LayoutProduct>;
